import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

/**
 * Deleting the account — described honestly, and not offered yet.
 *
 * There is no deletion path in the API, and this page does not pretend
 * otherwise. A button that appears to delete an account and does not is the
 * worst possible thing on a settings screen: she believes her data is gone.
 *
 * It is also genuinely not a one-liner, and AGENTS.md says why. `organization`
 * is not a child of `user`: deleting her cascades her sessions, accounts,
 * profile, feeds, LinkedIn grant and membership, and leaves the organization
 * standing with every contact, move, outcome, map and room inside it. A real
 * closure path has to delete orgs first — and only those where she is the last
 * member — then the user, and sign out before deleting, because sessions are
 * served from a signed cookie for five minutes and dropping the row alone
 * leaves a working cookie for a workspace that no longer exists.
 *
 * So this page states what deletion would take with it, which is the part she
 * actually needs to decide, and says the button is not there yet.
 */
export const Route = createFileRoute("/settings/account")({
  component: Account,
});

function Account() {
  return (
    <div className="setwrap">
      <header className="sethead">
        <Link to="/settings" className="setback">
          <ArrowLeft size={16} aria-hidden />
          Settings
        </Link>
        <h1 className="settitle">Delete my account</h1>
      </header>

      <section className="setnote">
        <h2>Not available yet</h2>
        <p>
          Omina cannot delete an account from inside the app yet, and it will
          not show you a button that pretends to.
        </p>
        <p>What deletion will take with it when it exists:</p>
        <ul>
          <li>Your sign-in, sessions and Google connection</li>
          <li>Your profile, blueprints and interests</li>
          <li>Your workspace — contacts, rooms, outcomes and maps</li>
        </ul>
        <p>
          Disconnecting Google is a separate thing and can be done from your
          Google account at any time, whether or not this exists.
        </p>
      </section>
    </div>
  );
}
